var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-await"},[(_vm.awaiting)?_vm._t("default"):_vm._e(),(_vm.success)?_vm._t("then",null,null,_vm.value):_vm._e(),(_vm.error)?_vm._t("catch",null,null,_vm.err):_vm._e(),(_vm.none)?_vm._t("none"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }